import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
    selector: 'acm-title-logo',
    imports: [],
    templateUrl: './title-logo.component.html',
    styleUrls: ['./title-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleLogoComponent {
    @ViewChild('logoWithoutTm') logoWithoutTm!: ElementRef;
    @ViewChild('svgLogoParent') svgLogoParent!: ElementRef;

    _appName = 'Aperture Credentials Management';

    _viewBoxData = {
        minX: 0,
        minY: 0,
        width: 0,
        height: 32,
    };

    currentViewBoxString: string = this.viewBoxString();

    @Input()
    set appName(val: string) {
        this._appName = val;
        this.setBoundingBox();
    }

    private setBoundingBox(): void {
        this.currentViewBoxString = this.viewBoxString();
    }

    viewBoxString(): string {
        return `${this._viewBoxData.minX} ${this._viewBoxData.minY} ${this._viewBoxData.width} ${this._viewBoxData.height}`;
    }
}
